import React, { useState } from "react";
import {
  LoadingBtn,
  MandatoryStarWrapper,
  PageDescription,
  PageTitle,
  PageTopSection,
  PageWrapper,
} from "utility/styled-components";
import { InquiryLeft, InquiryRight, InquiryWrapper } from "./styles";
import {
  GridElementFullWidth,
  OnboardingFormGrid,
} from "pages/onboarding/style";
import { Button, TextField } from "@mui/material";
import {
  ButtonsLeftWrapper,
  customiseMaterialUITextBoxStyle,
  secondaryButtonStyles,
} from "utility/styles";
import { resetText, submitText } from "utility/constants";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { raiseEnquiryValidationSchema } from "./ducks/validationSchema";
import { reactToastify, ToastType } from "utility/reactToastify";
import { raiseInquiry } from "services/EmailService";
import { useSelector } from "react-redux";
import { RootState } from "api-store/store";
import { FormError } from "shared-compoents/form-components";

function RaiseInquiry() {
  const [isSubmittingForm, setIsSubmittingForm] = useState(false);
  const userData = useSelector((state: RootState) => state.userData);

  const RAISE_INQUIRY_CONSTANTS = {
    title: "Raise Inquiry",
    description:
      "Have a suggestion? We’d love to hear it and make it a reality for you.",
  };
  const RAISE_INQUIRY_FORM_PLACEHOLDERS = {
    name: "Name",
    message: "Message",
    email: "Email",
    topic: "Topic"
  };
  const  { register, reset, handleSubmit, formState } = useForm({
    resolver: yupResolver(raiseEnquiryValidationSchema),
    values: {
        name: userData.name,
        email: userData.user_name.replace("tmnatest", "toyota"),
        topic: "",
        message: ""
      },
      mode: "onChange",
  })

  const { errors } = formState;

  const onClickReset = () => {
    reset(undefined, { keepDirtyValues: false });
  }

  const onSubmit = async (fromData: any) => {
    try {
        setIsSubmittingForm(true);
        await raiseInquiry(fromData.email, fromData.topic, fromData.message, fromData.name);
        onClickReset();
        reactToastify({
            message: "Inquiry Sent Successfully",
            description: "",
            action: undefined,
            type: ToastType.success
        });
    } catch(error) {
        console.log("Error", error);
    } finally {
        setIsSubmittingForm(false);
    }
  }
  
  return (
    <PageWrapper>
      <InquiryWrapper>
        <InquiryLeft>
          <PageTopSection>
            <PageTitle>{RAISE_INQUIRY_CONSTANTS.title}</PageTitle>
            <PageDescription>
              {RAISE_INQUIRY_CONSTANTS.description}
            </PageDescription>
          </PageTopSection>
          <div style={{ marginTop: "42px" }}>
            <OnboardingFormGrid>
              <GridElementFullWidth>
                <TextField
                  {...register("email")}
                  label={
                    <>
                      {RAISE_INQUIRY_FORM_PLACEHOLDERS.email}
                      <MandatoryStarWrapper>*</MandatoryStarWrapper>
                    </>
                  }
                  fullWidth
                  margin="normal"
                  variant="outlined"
                  sx={customiseMaterialUITextBoxStyle}
                  disabled={true}
                ></TextField>
                {errors && errors?.email ? (
                  <FormError>{errors?.email.message}</FormError>
                ) : (
                  <></>
                )}
              </GridElementFullWidth>
              <GridElementFullWidth>
                <TextField
                  // {...register("name")}]
                  {...register("name")}
                  label={
                    <>
                      {RAISE_INQUIRY_FORM_PLACEHOLDERS.name}
                      <MandatoryStarWrapper>*</MandatoryStarWrapper>
                    </>
                  }
                  fullWidth
                  margin="normal"
                  variant="outlined"
                  sx={customiseMaterialUITextBoxStyle}
                  disabled={true}
                ></TextField>
                {errors && errors?.name ? (
                  <FormError>{errors?.name.message}</FormError>
                ) : (
                  <></>
                )}
              </GridElementFullWidth>
              <GridElementFullWidth>
                <TextField
                  {...register("topic")}
                  label={
                    <>
                      {RAISE_INQUIRY_FORM_PLACEHOLDERS.topic}
                      <MandatoryStarWrapper>*</MandatoryStarWrapper>
                    </>
                  }
                  fullWidth
                  margin="normal"
                  variant="outlined"
                  sx={customiseMaterialUITextBoxStyle}
                  disabled={isSubmittingForm}
                ></TextField>
                {errors && errors?.topic ? (
                  <FormError>{errors?.topic.message}</FormError>
                ) : (
                  <></>
                )}
              </GridElementFullWidth>
              <GridElementFullWidth>
                <TextField
                  {...register("message")}
                  label={
                    <>
                      {RAISE_INQUIRY_FORM_PLACEHOLDERS.message}
                      <MandatoryStarWrapper>*</MandatoryStarWrapper>
                    </>
                  }
                  multiline
                  rows={8}
                  fullWidth
                  margin="normal"
                  variant="outlined"
                  sx={customiseMaterialUITextBoxStyle}
                  disabled={isSubmittingForm}
                ></TextField>
                {errors && errors?.message ? (
                  <FormError>{errors?.message.message}</FormError>
                ) : (
                  <></>
                )}
              </GridElementFullWidth>
              <ButtonsLeftWrapper>
                <LoadingBtn
                    onClick={handleSubmit(onSubmit)}
                    loading={isSubmittingForm}
                    loadingIndicator={"Submitting"}
                >
                  {!isSubmittingForm ? submitText : ""}
                </LoadingBtn>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={onClickReset}
                  sx={secondaryButtonStyles}
                >
                  { resetText }
                </Button>
              </ButtonsLeftWrapper>
            </OnboardingFormGrid>
          </div>
        </InquiryLeft>
        <InquiryRight>
            <img src="/assets/message-illustration.svg" alt="message illustration" />
        </InquiryRight>
      </InquiryWrapper>
    </PageWrapper>
  );
}

export default RaiseInquiry;
